import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieStorageService {
  /**
   *
   * @param {string} key
   * @param {any} value
   */

  put(key: string, value: any) {
    let cookie: string;

    if (value !== undefined && value !== null) {
      if (typeof value === 'object') {
        cookie = encodeURIComponent(key) + '=' + encodeURIComponent(JSON.stringify(value)) + ';path=/;';
      } else {
        cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value.toString()) + ';path=/;';
      }
    } else {
      cookie = encodeURIComponent(key) + '=;path=/;';
    }

    document.cookie = cookie;
  }

  /**
   *
   * @param {string} key
   * @returns {any}
   */

  get(key: string): any {
    if (!document.cookie) {
      return undefined;
    }

    const cookies: string[] = document.cookie.split('; ');

    for (const cookie of cookies) {
      const idx = cookie.indexOf('=');
      if (idx > 0 && decodeURIComponent(cookie.substring(0, idx)) === key) {
        const value = decodeURIComponent(cookie.substring(idx + 1));

        try {
          return JSON.parse(value);
        } catch (e) {
          return value;
        }
      }
    }
    return undefined;
  }

  remove(key: string): any {

    const cookies: string[] = document.cookie.split('; ');
    for (const cookie of cookies) {
      const idx = cookie.indexOf('=');
      if (idx > 0 && decodeURIComponent(cookie.substring(0, idx)) === key) {
        const value = decodeURIComponent(cookie.substring(idx + 1));

        try {
          decodeURIComponent(cookie.replace(cookie.substring(idx + 1),''));
        } catch (e) {
          return value;
        }
      }
    }
  }
}
